import { OrdersScreen } from '../features/orders/OrdersScreen'
import { useShell } from '../app/outlet'

export function OrdersPage() {
  const { toast } = useShell()
  return <OrdersScreen onToast={toast} />
}
